import i18n from '../../../locales/index';
import { featureFlag } from '../../entities/feature-flag';

export const dashboardModuleRoutes = {
	path: 'dashboard',
	component: () => import('./module-layout.vue'),
	meta: {
		featureFlag: [featureFlag.E_COMMERCE, featureFlag.AI_AGENT],
	},
	children: [
		{
			path: 'main',
			component: () => import('./pages/main-dashboard/index.vue'),
			meta: {
				title: i18n.global.t('dashboard.title'),
			},
		},
	],
};
